import LogoShowcase from './Components/LogoShowcase/LogoShowcase';
import EnterpriseFeatures from './Components/EnterpriseFeatures/EnterpriseFeatures';
import IntegrationHero from './Components/Integrations/Integrations';
import ImpactMetrics from './Components/ImapctMetrics/DriveResults';
import SuccessStories from './Components/SuccessStories/SuccessStories';
import ReadyToTransformHero from './Components/ReadyToTransformEnterpriseTraning/ReadyToTransformHero';
import GetStartedHero from './Components/ReadyToTranformTeamLearning/GetStartedHero';
import HeroSection from './Components/HeroSection/HeroSection';

const LandingPage = () => {
  return (
    <div style={{background:"var(--color-card-bg)"}}>
    <HeroSection/>
    <LogoShowcase/>
    <EnterpriseFeatures/>
    <IntegrationHero/>
    <ImpactMetrics/>
    <SuccessStories/>
    <ReadyToTransformHero/>
    <GetStartedHero/>
    </div>
  );
};

export default LandingPage;